export default __webpack_public_path__ + "static/media/lic3.b0458a22.svg";